export const defaultStrings = {
  'label.country': 'Country',
  'label.address1': 'Street address',
  'label.address2': 'Suite/Floor/Building (optional)',
  'label.city': 'City',
  'label.state': 'State',
  'label.county': 'County',
  'label.province': 'Province',
  'label.region': 'Region',
  'label.zip_code': 'Zip code',
  'label.eircode': 'Eircode',
  'label.postal_code': 'Postal code',
  'placeholder.address': 'Please enter an address',
  'error.required.address': 'Street address is required',
  'error.required.city': 'City is required',
  'error.required.province': 'Province is required',
  'error.required.state': 'State is required',
  'error.required.zip_code': 'Zip code is required',
  'error.required.eircode': 'Eircode is required',
  'error.required.postal_code': 'Postal code is required',
  'error.match.zip_code': 'Please enter a valid zip code',
  'error.match.eircode': 'Please enter a valid Eircode',
  'error.match.postal_code': 'Please enter a valid postal code'
}

export type DefaultStrings = typeof defaultStrings
